var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouseholdJustMe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4584 0.725389C9.43338 1.50039 7.53338 3.87539 7.50838 6.87539C7.48338 9.42539 8.90838 11.7004 11.2084 12.7754C12.5334 13.4004 15.1084 13.4004 16.4584 12.7754C21.1834 10.6254 21.4334 3.70039 16.8584 1.37539C15.5334 0.70039 13.6084 0.425389 12.4584 0.725389Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2083 15.1C5.9083 16.15 3.0083 18.625 1.6333 21.525C0.683304 23.525 0.108304 26.55 0.583304 27.125C0.858304 27.45 2.5333 27.5 13.8333 27.5C25.1333 27.5 26.8083 27.45 27.0833 27.125C27.3333 26.825 27.3333 26.375 27.1083 24.95C26.3583 20.425 23.2083 16.7 18.9083 15.275C17.6083 14.825 16.7583 14.75 13.7833 14.775C11.6083 14.775 9.8083 14.9 9.2083 15.1Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseholdJustMe);
export default __webpack_public_path__ + "static/media/household-just-me.2cb33b09fd11332d88e3338ca04d4a0d.svg";
export { ForwardRef as ReactComponent };